<template>
  <div class="subscribe-to-availability">
    <form @submit.prevent="informAvailability">
      <DefButtonSecondary :type="'submit'">
        {{ messages.informAvailability }}
      </DefButtonSecondary>
      <DefPhone :placeholder="messages.phone" :name="'phone'" :value="userPhone" :required="true" />
    </form>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DefPhone from '@components/Def/DefPhone/DefPhone.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import ProductInformAvailability from '@components/Product/Modals/ProductInformAvailability.vue';
import useModal from '@use/useModal/useModal';

export default {
  name: 'SubscribeToAvailability',
  components: { DefButtonSecondary, DefPhone },
  data() {
    return {
      modal: useModal(),
    };
  },
  methods: {
    handlerShowResponseModal(result) {
      this.modal.show(ProductInformAvailability, { result }, { width: '340px' });
    },
    async informAvailability({ target }) {
      const formData = new FormData(target);
      try {
        const routes = this.product?.routes?.informAvailability;
        const {
          path,
          'params-example-data': { action },
        } = routes;

        if (action && path) {
          formData.append('action', action);
          formData.append('productId', this.id);
          formData.append('LANGUAGE_ID', this.lang.LANGUAGE_ID);

          const { status, data } = await axios.post(path, formData);

          this.handlerShowResponseModal(data);

          if (status !== 200) {
            throw `bad request response status: ${status} \n url: ${path}`;
          }
        } else {
          throw `action: ${action} or path: ${path} is empty`;
        }
      } catch (err) {
        console.error(err);
      }
    },
  },
  computed: {
    ...mapGetters({
      id: 'product/id',
      lang: 'getRequestLang',
    }),
    ...mapState({
      product: ({ product }) => product.data.product,
      messages: ({ product }) => product.data.messages,
      userPhone: ({ personal }) => personal.data.authInfo?.user_phone_number,
    }),
  },
};
</script>

<style lang="scss" scoped>
.subscribe-to-availability {
  flex-grow: 1;
  margin-right: 8px;
  :deep(.def-button-secondary) {
    display: flex;
    height: 56px;
    width: 100%;
    margin-bottom: 24px;
  }
}
</style>
